import React, { useState } from 'react';
import { Modal, Input, Button, DatePicker, Checkbox, Typography } from 'antd';
import { closeTaskLead } from 'redux/spot/spot-actions';
import { useSelector } from 'react-redux';
import styles from './lead-task.module.scss';

export const LeadTaskModal = ({ tasks, createUserTask, updateUserTaskStatus }) => {
  const { isTaskLeadOpen, selectedLead } = useSelector((state) => state.spot);

  const [newTask, setNewTask] = useState('');
  const [date, setDate] = useState(null);

  const onDateChange = (date) => {
    setDate(date);
  };

  const onAddTask = async () => {
    await createUserTask(selectedLead.id, newTask, date);
  };

  const updateTaskStatus = async (taskId, status) => {
    await updateUserTaskStatus(taskId, status);
  };

  return (
    <Modal
      title={`Task Management - Lead ID: ${selectedLead?.id}`}
      open={isTaskLeadOpen}
      onCancel={closeTaskLead}
      footer={null}>
      <div className={styles.taskContainer}>
        <Input
          placeholder="Add a new task..."
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          className={styles.taskInput}
        />
        <DatePicker value={date} onChange={onDateChange} className={styles.datePicker} />
        <Button onClick={onAddTask} className={styles.addButton}>
          Add
        </Button>
      </div>

      <List
        title="Pending Tasks"
        tasks={tasks.pending.filter((task) => task.lead_id === selectedLead?.id) || []}
        onChange={updateTaskStatus}
        emptyText="No pending tasks"
      />
      <List
        check
        title="Completed Tasks"
        tasks={tasks.completed.filter((task) => task.lead_id === selectedLead?.id) || []}
        onChange={updateTaskStatus}
        emptyText="No completed tasks"
      />
    </Modal>
  );
};

const List = ({ check, title, tasks, onChange, emptyText }) => {
  return (
    <div className={styles.list}>
      <Typography.Title level={5} className={styles.taskTitle}>
        {title}
      </Typography.Title>
      {tasks.length === 0 ? (
        <p className={styles.noTasksMessage}>{emptyText}</p>
      ) : (
        <div className={styles.taskListContainer}>
          {tasks.map((task) => (
            <div key={task.id} className={styles.taskItem}>
              <Checkbox
                checked={check}
                onChange={() => onChange(task.id, task.status === 'completed' ? 'pending' : 'completed')}
                className={styles.taskCheckbox}
              />
              <div className={styles.taskContent}>
                <p className={`${styles.taskTitle} ${check ? styles.taskCompleted : ''}`}>{task.task}</p>
                <p className={styles.taskDueDate}>
                  Due:{' '}
                  {new Date(task.due_date).toLocaleDateString('en', { year: 'numeric', month: 'long', day: 'numeric' })}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
